import { AppConfigurationVariable as ConfigurationVariable } from 'graphql/models/extended';

export function isCalculatedValue(item: ConfigurationVariable): boolean {
  return (item.showAsProp && item.showAsProp.valueText === 'Calculated');
}
